import React, {useEffect} from "react";
import {Dialog} from "@material-ui/core";
import {Button} from "../../Button";
import warningImage from "../../../images/warning.svg"
import {ReactSVG} from "react-svg";
import {strings} from "../../../strings/strings";

export const BuyMTPLDialog = ({open, onCancel}) => {
    useEffect(() => {
        if (open) {
            let event = 'osago_emtpl_smart_pop_up';
            console.log('Google Analytics Event = ' + event);
            // @ts-ignore
            window.dataLayer.push({'event': event});
        }
    }, [open]);

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dialog"}>
                <div className={"dialog__content"}>
                    <ReactSVG src={warningImage} style={{alignSelf: 'center'}}/>

                    <p className={"dialog__message"}>
                        {strings.buyMTPLDlg.message}
                    </p>

                    <Button label={strings.buyMTPLDlg.btnNext} onClickListener={() =>
                        window.location.replace(strings.refs.emtpl)
                    }/>

                    <Button label={strings.buyMTPLDlg.btnCancel} variant={"link"} onClickListener={onCancel}/>
                </div>
            </div>
        </Dialog>
    )
}
